import { render, staticRenderFns } from "./ADate.vue?vue&type=template&id=84c7a31e&"
import script from "./ADate.vue?vue&type=script&lang=js&"
export * from "./ADate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports